/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pdc_Action_RejectInputs */

const vi_pdc_action_reject = /** @type {(inputs: Pdc_Action_RejectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Từ chối`)
};

/**

* @param {Pdc_Action_RejectInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pdc_action_reject = /** @type {((inputs?: Pdc_Action_RejectInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pdc_Action_RejectInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pdc_action_reject(inputs)
});